import React, { useEffect, useState } from 'react';
import { getAllPortfolios } from '../../common/portfolioStore';

function Numbers() {
  const [portfolioCount, setPortfolioCount] = useState(null);
  const yearsExp = new Date().getFullYear() - 2024;

  useEffect(() => {
    getAllPortfolios()
      .then((data) => setPortfolioCount(data.length))
      .catch(() => setPortfolioCount(0));
  }, []);

  return (
    <section className="numbers-crev section-padding o-hidden">
      <div className="container">
        <div className="row lg-marg justify-content-center">
          <div className="col-lg-4 col-md-6">
            <div className="item text-center md-mb50">
              <h3 className="stroke">100%</h3>
              <h6 className="p-color sub-title">Müşteri Memnuniyeti</h6>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="item text-center md-mb50">
              <h3 className="stroke">
                {portfolioCount !== null ? `${portfolioCount}+` : '...'}
              </h3>
              <h6 className="p-color sub-title">Yayındaki Projeler</h6>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="item text-center">
              <h3 className="stroke">{yearsExp}+</h3>
              <h6 className="p-color sub-title">Yıllık Deneyim</h6>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Numbers;
